module.exports = __webpack_public_path__ + "static/media/nig_logo.e6493ee4.png";